import { Suspense } from "react";

import { MapPanel } from "~/modules/map/components/MapPanel";

import { MapEditorPlannerAreaPanelContent } from "./MapEditorPlannerAreaPanelContent";
import { MapEditorPlannerAreaPanelSkeleton } from "./MapEditorPlannerAreaPanelSkeleton";

export interface MapEditorPlannerAreaPanelProps {
    backHref: string;
    mapEditorFeatureId: string;
    readonly: boolean;
    title: string;
}

export function MapEditorPlannerAreaPanel({ backHref, mapEditorFeatureId, readonly, title }: MapEditorPlannerAreaPanelProps) {
    return (
        <MapPanel>
            <Suspense key={mapEditorFeatureId} fallback={<MapEditorPlannerAreaPanelSkeleton />}>
                <MapEditorPlannerAreaPanelContent
                    backHref={backHref}
                    mapEditorFeatureId={mapEditorFeatureId}
                    readonly={readonly}
                    title={title}
                />
            </Suspense>
        </MapPanel>
    );
}
